// Runtime white-labeling + feature flags for a customer instance. Loaded once
// at boot (before React renders) from /api/instance-config, which the backend
// derives from this customer's env. Everything downstream reads BRAND/FEATURES.
export const BRAND = { name: "Helpdesk", logo_url: "/logo.jpg", tagline: "Support Platform", primary_color: null };
// Feature flags = what the customer's PLAN + configuration unlocks. All paid
// add-ons default OFF so nothing is auto-included; the server sends the real
// values from /api/instance-config (derived from the license plan).
export const FEATURES = {
  m365_sso: false,        // O365 SSO — only when the customer configured Azure
  server_rmm: false,      // Server RMM add-on
  client_database: false, // Client & Website Registry add-on
  dev_queue: false,
  infrastructure: false,
  mdm: false,
  ftr_ai: false,
  security: false,
};

export async function loadBrand() {
  const base = process.env.REACT_APP_API_URL || "";
  try {
    const r = await fetch(base + "/api/instance-config");
    if (r.ok) {
      const d = await r.json();
      if (d.brand) {
        if (d.brand.name) BRAND.name = d.brand.name;
        if (d.brand.logo_url) BRAND.logo_url = d.brand.logo_url;
        if (typeof d.brand.tagline === "string") BRAND.tagline = d.brand.tagline;
        BRAND.primary_color = d.brand.primary_color || null;
      }
      if (d.features) Object.assign(FEATURES, d.features);
    }
  } catch { /* keep neutral defaults */ }
  try { document.title = BRAND.name; } catch {}
  if (BRAND.primary_color) { try { document.documentElement.style.setProperty("--brand-primary", BRAND.primary_color); } catch {} }
}
